import { Link } from "react-router-dom";

const LOGO_URL = "/rapro-logo.png";
const LOGO_SIZE_LIGHT_PX = 96;
const LOGO_SIZE_DARK_PX = 112;

export const Logo = ({ variant = "light", testId = "site-logo" }) => {
  const isDark = variant === "dark";
  const sizePx = isDark ? LOGO_SIZE_DARK_PX : LOGO_SIZE_LIGHT_PX;
  return (
    <Link
      to="/"
      data-testid={testId}
      className="inline-flex items-center group"
      aria-label="RAPRO Solutions — Home"
    >
      <img
        src={LOGO_URL}
        alt="RAPRO Solutions logo"
        className="object-contain transition-transform duration-150 group-hover:-rotate-2"
        loading="eager"
        style={{
          height: sizePx,
          width: "auto",
        }}
      />
    </Link>
  );
};

export default Logo;
